import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  MenuIcon,
  ShipmentIcon,
  PickupsIcon,
  ExportDataIcon,
  TicketsIcon,
  AdvancedSearch,
  NewShipment,
  complaint,
  DataAnalysis,
  AiAssistant,
} from "../../assets/icons";
import { useTranslation } from "react-i18next";

export default function Sidebar() {
  const [sideOpen, setSideOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { t, i18n } = useTranslation("layout");

  const AuthedUser = JSON.parse(localStorage.getItem("AuthedUser")) || {};
  const { DataAnalysisLink } = AuthedUser;

  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (windowWidth < 900) {
    return null;
  }

  const menuItems = [
    { to: "/", icon: MenuIcon, label: t("Sidebar.Menu") },
    {
      to: "/reports/shipments",
      icon: ShipmentIcon,
      label: t("Sidebar.Shipments"),
    },
    { to: "/reports/pickups", icon: PickupsIcon, label: t("Sidebar.Pickups") },
    {
      to: "/reports/export",
      icon: ExportDataIcon,
      label: t("Sidebar.Reports_ExportData"),
    },
    {
      to: "/multi-search",
      icon: AdvancedSearch,
      label: t("Sidebar.Advanced_Search"),
    },
    { to: "/tickets", icon: TicketsIcon, label: t("Sidebar.Tickets") },
    {
      to: "/quick-newshipment",
      icon: NewShipment,
      label: t("Sidebar.Quick_NewShipment"),
    },
    { to: "/cs-home", icon: complaint, label: t("Sidebar.Add_Complaint") },
  ];

  if (DataAnalysisLink && DataAnalysisLink.trim() !== "") {
    menuItems.push({
      to: "/data-analysis",
      icon: DataAnalysis,
      label: t("Sidebar.data_analysis"),
    });
  }
  menuItems.push({
    to: "/ai-assistant",
    icon: AiAssistant,
    label: t("Sidebar.ai_assistant"),
  });

  return (
    <div
      dir={isRTL ? "rtl" : "ltr"}
      style={{
        width: sideOpen ? 220 : 60,
        transition: "width 0.5s",
        height: "100vh",
        backgroundColor: "var(--primary-color)",
        color: "white",
        fontWeight: 500,
        position: "sticky",
        top: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Toggle Button */}
      <div
        onClick={() => setSideOpen(!sideOpen)}
        style={{
          cursor: "pointer",
          padding: 10,
          textAlign: "center",
          borderBottom: "1px solid var(--primary-color)",
        }}
      >
        {sideOpen ? (isRTL ? "→" : "←") : isRTL ? "←" : "→"}
      </div>

      {/* Menu Items */}
      <nav style={{ flex: 1, width: "100%" }}>
        {menuItems.map(({ to, icon, label }) => (
          <Link
            key={to}
            to={to}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 15px 15px 15px",
              color: "white",
              textDecoration: "none",
              borderBottom: "1px solid #ffffff70",
              whiteSpace: "nowrap",
            }}
          >
            <img
              src={icon}
              alt={label}
              style={{
                width: 30,
                height: 30,
                marginRight: !isRTL && sideOpen ? 10 : 0,
                marginLeft: isRTL && sideOpen ? 10 : 0,
              }}
            />
            {sideOpen && <span>{label}</span>}
          </Link>
        ))}
      </nav>
    </div>
  );
}
